export const copyWithoutRef = <T>(object: T): T => {
  const rateProgramClone: any = Object.assign({}, object);
  delete rateProgramClone.ref;
  return rateProgramClone;
};
